// extracted by mini-css-extract-plugin
module.exports = {"section":"section-module--section--Rms0L","fullWidth":"section-module--full-width--22pVg"};